import React from 'react';
import { View } from 'react-native';

import { OPComponent, I18n, Navigation } from '../../components';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { addCase, updateCaseEmployer } from '../actions';

import PersonForm from './person_form';

import {
  getLocationsByRegionForCurrentEmployer,
  getLocationsByRegionForEditingCaseEmployer,
} from '../../medRecruiter/selector';

import { SUCCESS } from '../../../actions/statusTypes';

const createFormRef = React.createRef();
class CaseFieldsMedRecruiter extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {};
    this._isCreate = !props.editingCase;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.status === SUCCESS && prevProps.status !== SUCCESS) {
      if (this._isCreate) {
        // go to schedule screen
        Navigation.openScreen(
          {
            screen: 'StaffScheduleForm',
            title: 'Provider Hours',
            passProps: {
              noBacksies: true,
              startDate: this._startDate,
              onClose: this.showScheduleTab,
            },
          },
          this.props.componentId
        );
      } else {
        this.props.onSave();
      }
    }
  }

  showScheduleTab() {
    Navigation.handleDeepLink({
      link: 'employer/main',
    });
  }

  submit = () => {
    const props = this.props;
    const requestObj = createFormRef?.current?.submit();
    if (requestObj) {
      if (props.editingCase) {
        let caseObj = {
          clinical_location_id: requestObj.clinical_location_id,
        };
        let patientObj = {
          fullName: requestObj.name,
          email: requestObj.email,
          phone: requestObj.phone,
          birthDate: requestObj.birthDate,
          role: requestObj.patientRole,
        };
        props.actions.updateCaseEmployer(props.editingCase.caseId, { caseObj, patientObj });
      } else {
        const employer = this.props.currentEmployer;
        const caseObj = {
          ...requestObj,
          description: requestObj.name,
          patient: {
            email: requestObj.email,
            name: requestObj.name,
            phone: requestObj.phone,
            birthDate: requestObj.birthDate,
            role: requestObj.patientRole,
          },
        };
        delete caseObj.role;
        this._startDate = requestObj.startDate;
        this.props.addCase(caseObj, employer.employerId);
      }
      return true;
    } else {
      return false;
    }
  };

  render() {
    const props = this.props;
    const omittedFields = [];
    if (props.editingCase) {
      omittedFields.push('email');
    }
    return (
      <View style={[{ zIndex: 1000, paddingBottom: 30, paddingHorizontal: 35, paddingTop: 15 }]}>
        <PersonForm
          ref={createFormRef}
          staffOnly={false}
          providerOnly={!props.editingCase}
          singlePagePatientForm={true}
          editingCase={props.editingCase}
          editingCasePatient={props.editingCasePatient}
          editingCaseEmployer={props.editingCaseEmployer}
          locationsByRegion={props.locationsByRegion}
          omittedFields={omittedFields}
        />
      </View>
    );
  }
}

function mapStateToProps(state, ownProps) {
  let locationsByRegion = {};
  if (ownProps.editingCase) {
    locationsByRegion = getLocationsByRegionForEditingCaseEmployer(state);
  } else {
    locationsByRegion = getLocationsByRegionForCurrentEmployer(state);
  }
  return {
    status: state.screens.cases.status,
    locationsByRegion,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        addCase,
        updateCaseEmployer,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(
  CaseFieldsMedRecruiter
);
